import React, { PureComponent } from 'react';
import { encodeForURI } from 'appSrc/utils';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { dAPI } from 'appSrc/api';
import { convertImage, extractHostname, deriveListSlug } from 'appSrc/utils';
import { Link } from 'react-router-dom';
import Like from 'appSrc/components/Like';
import TextTruncate from 'react-text-truncate';
import TagDisplay from 'appSrc/components/Tag/Display';
import { VideoPlayer } from 'appSrc/components/Shards';
import ShareGroup from 'appSrc/components/Share/Group';
import { UserAvatar, RightChevron, DLMenu, Icon, GridCard } from 'appSrc/components/UI';
import ListCoverImage from 'appSrc/components/List/CoverImage';
import AspectRatio from 'react-aspect-ratio';
import MiniCarousel from 'appSrc/components/Carousel/Mini';
import { Mixpanel } from 'appSrc/components/Analytics/Mixpanel';
import style from './styles/style.module.css';

import defaultListCoverImage from 'appSrc/assets/img/list/default_list_image.png';

class ListCard extends PureComponent {
    constructor(props) {
        super( props );

        this.state = {
            videoPlaying: false,
        };
    }
    renderCoverImage = ( list ) => {
        if( list.youtube ) {
            return (
                <VideoPlayer
                videoId={ list.youtube }
                onActivate={ () => {
                    this.setState( { videoPlaying: true } );
                } }
                coverImage={ list.coverImage }
                authorId={ list.userid } attachmentType='list_cover_video' attachmentId={ list.listid } />
            );
        }
        const coverImage = list.coverImage || defaultListCoverImage;
        return (
            <ListCoverImage coverImage={ coverImage } />
        );
    }
    trackShare = ( medium ) => {
        this.props.noteListShare( this.props.listItem.listid )
        .then( ( list ) => {
            var coverType = !!list.youtube ? 'video' : !!list.coverImage ? 'image' : 'none';
            Mixpanel.track( 'listShared', {
                id: list.listid,
                name: list.title,
                user_id: list.userid,
                date_created: list.dateCreated,
                published: list.published,
                like_count: parseInt( list.likes ),
                // purchase_count: '?',
                view_count: parseInt( list.views ),
                search_count: list.searches,
                share_count: list.shares,
                cover_type: coverType,
                share_medium: medium,
                author: list.userid,
            } );
        } );
    }
    confirmDelete = () => {
        if( window.confirm( 'Do you really want to delete this list?' ) ) {
            this.deleteList();
        }
    }
    deleteList = () => {
        var list = this.props.listItem.asMutable ? this.props.listItem.asMutable() : this.props.listItem;
        this.props.deleteList( list.listid )
        .then( () => {
            try {
                var coverType = !!list.youtube ? 'video' : !!list.coverImage ? 'image' : 'none';
                var likes = !list.likes ? 0 : parseInt( list.likes );
                var views = !list.views ? 0 : parseInt( list.views );
                Mixpanel.track( 'listDeleted', {
                    id: list.listid,
                    name: list.title,
                    user_id: list.userid,
                    date_created: list.dateCreated,
                    published: list.published,
                    like_count: likes,
                    // purchase_count: '?',
                    view_count: views,
                    // search_count: 0,
                    // share_count: 0,
                    cover_type: coverType,
                    author: list.userid,
                } );
            } catch (e) {
                console.warn( 'Analytics error: ', e );
            } finally {
                this.props.onChange( null );
            }
        } )
        .catch( () => {
            window.alert( 'List not deleted. Please try again.' );
        } );
    }
    publishList = () => {
        var list = this.props.listItem.asMutable ? this.props.listItem.asMutable() : this.props.listItem;
        this.props.publishList( list.listid )
        .then( ( list ) => {
            try {
                var coverType = !!list.youtube ? 'video' : !!list.coverImage ? 'image' : 'none';
                var likes = !list.likes ? 0 : parseInt( list.likes );
                var views = !list.views ? 0 : parseInt( list.views );
                Mixpanel.track( 'listPublished', {
                    id: list.listid,
                    name: list.title,
                    user_id: list.userid,
                    date_created: list.dateCreated,
                    published: list.published,
                    like_count: likes,
                    // purchase_count: '?',
                    view_count: views,
                    // search_count: 0,
                    // share_count: 0,
                    cover_type: coverType,
                    author: list.userid,
                } );
            } catch (e) {
                console.warn( 'Analytics error: ', e );
            } finally {
                this.props.onChange( list );
            }
        } )
        .catch( () => {
            window.alert( 'List not published. Please try again.' );
        } );
    }




    render() {
        const { listItem } = this.props;
        const { videoPlaying } = this.state;
        const author = listItem.author || {};
        const profession = ( author.profession || {} ).title;
        const listSlug = deriveListSlug( listItem, ( listItem.userid == this.props.self.userid ) );

        const category = listItem.interests && listItem.interests[0] || {};
        const categorySlug = `/app/explore/${ category.slug }`;
        const showCategory = category.interestid && !category.deactivated;

        return (
            <GridCard className={ style.listCard }
            style={ { ...this.props.style } }
            data-video-playing={ videoPlaying }
            data-hook='list-card'>
                <Link to={ listSlug } className={ style.backgroundLink }></Link>
                <div className={ style.cardContent }>
                    <AspectRatio
                    ratio='16/9'>
                        <div className={ style.imageWrapper }
                        data-hook='list-card-cover-image'>
                            { this.renderCoverImage( listItem ) }
                            { !videoPlaying &&
                                <div className={ style.listInfo }>
                                    <Link to={ listSlug } className={ style.linkWrapper }>
                                        <div className={ style.listTitle } title={ listItem.title }>{ listItem.title }</div>
                                    </Link>
                                    <div className={ style.tagsWrapper }>
                                        <TagDisplay tags={ listItem.tags } white />
                                    </div>
                                </div>
                            }
                        </div>
                    </AspectRatio>

                    <div className={ style.titleBarWrapper }>
                        <div className={ style.divider } />
                        <div className={ style.titleBar } data-hook='list-card-title-bar'>
                            <div>
                                { author &&
                                <Link to={ `/${ author.slug }` } className={ style.userIcon }>
                                    <UserAvatar src={ author.avatar } size={ 80 } />
                                </Link>
                                }
                            </div>
                            { showCategory &&
                                <div className={ style.listCategory }><Link to={ categorySlug }>{ category.interest }</Link></div>
                            }
                            { this.renderExternalLink( listItem ) }
                        </div>
                    </div>
                    <div className={ style.listRelations }>
                        <p className={ style.listAuthor }
                        title={ author.displayName }>
                            <Link to={ `/${ author.slug }` } >by <span className={ style.name }>{ author.displayName }</span>
                                { profession && ', ' }
                                { profession &&
                            <span title={ profession } className={ style.profession }>{ profession }</span>
                                }
                            </Link></p>
                    </div>

                    { this.renderDescriptionAndProducts( listItem ) }
                    <div className={ style.bottomLinks }>
                        <div className={ style.iconWrapper }>
                            <div className={ style.shareIcons }>
                                { this.renderShareGroup( listItem ) }
                                <Like type='list' item={ listItem }
                                size={ 15 } style={ { marginLeft: '12px' } } />
                            </div>
                        </div>
                        <div className={ style.productsLink }>
                            <Link to={ listSlug }>
                                SEE MORE <RightChevron size={ 12 } style={ { display: 'inline-block', verticalAlign: 'unset' } } />
                            </Link>
                        </div>
                    </div>
                </div>
                { this.props.canEdit && this.props.draft &&
                    <div className={ style.draftOverlay }>
                        <Link to={ listSlug } className={ style.backgroundLink }></Link>
                        <div className={ style.label }>Draft</div>
                    </div>
                }
                { this.props.canEdit &&
                    <div className={ style.menu }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: 'white' } } faSize='2x' /> ) }
                        direction='left' >
                            { !listItem.published &&
                                <DLMenu.Item text='Publish' onClick={ this.publishList }
                                icon={ ( <Icon source='fontAwesome' icon='fas/faCheckCircle' style={ { color: 'green' } } /> ) } />
                            }
                            <DLMenu.Item text='Edit' onClick={ () => { this.props.redirect( listSlug ); } }
                            icon={ ( <Icon source='fontAwesome' icon='fas/faEdit' style={ { color: '#bcbcbc' } } /> ) } />
                            <DLMenu.Item text='Delete' onClick={ this.confirmDelete }
                            icon={ ( <Icon source='fontAwesome' icon='fas/faTrash' style={ { color: 'red' } } /> ) } />
                        </DLMenu>
                    </div>
                }
            </GridCard>
        );
    }


    renderDescriptionAndProducts = ( list ) => {
        const extendDescription = list.desires.length == 0;
        if( extendDescription ) {
            var lineCount = 2;
            if( this._descriptionEl && this._descriptionEl.clientHeight ) {
                lineCount = Math.floor( this._descriptionEl.clientHeight / 20  );
            }
            return (
                <div className={ `${ style.listSpecifics } ${ style.extendedDescription }` } >
                    <div className={ style.detailsWrapper } ref={ ( el ) => { this._descriptionEl = el; } }>
                        <TextTruncate
                        line={ lineCount }
                        text={ list.description }
                        containerClassName={ style.description } />
                    </div>
                </div>
            );
        }
        var products = list.desires;
        return (
            <div className={ style.listSpecifics }>
                <div className={ style.detailsWrapper }>
                    <TextTruncate
                    line={ 1 }
                    text={ list.description }
                    containerClassName={ style.description } />
                </div>
                <AspectRatio
                ratio='100/17'
                className={ style.productsWrapper } >
                    <div className={ style.products }>
                        <MiniCarousel>
                            { products.map( ( product, index ) => {
                                if( product === null ) {
                                    return (
                                        <div key={ `null-product-${ index }` } className={ style.productItem }>
                                            <img
                                        src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAQAAAAm93DmAAAAKElEQVR42u3MQQEAAAQEMBdGTtWF4LkFWHrqVYRCoVAoFAqFQqHwZgEivRnJjY+8/AAAAABJRU5ErkJggg==' />
                                        </div>
                                    );
                                }
                                return (
                                    <div key={ product.desireid } className={ style.productItem }>
                                        <Link to={ '/app/products/' + product.desireid + '/' + encodeForURI(product.title) }>
                                            <img src={ convertImage( product.image, '/150x150' ) } />
                                        </Link>
                                    </div>
                                );
                            } ) }
                        </MiniCarousel>
                    </div>
                </AspectRatio>
            </div>
        );
    }
    renderExternalLink = ( list ) => {
        const externalLink = list.externalurl;
        if( !externalLink ) {
            return (
                <div className={ style.externalLink }>
                </div>
            );
        }
        const externalLinkText = ( list.externalurldisplaytext || '' ).toUpperCase() || extractHostname( externalLink );
        return (
            <div className={ style.externalLink }>
                <a href={ externalLink } target='_blank' rel='noopener noreferrer'>{ externalLinkText }</a>
            </div>
        );
    }
    renderShareGroup = ( list ) => {
        const author = list.author;
        const listSlug = `/${ author.slug }/${ list.slug }/`;
        const shareImage = !!list.coverImage ? convertImage( list.coverImage )
            : defaultListCoverImage;
        const shareUrl = window.location.host + listSlug;
        const emailShareProps = {
            subject: 'Check out this list on Desire Co.',
            message: `Thought you might like this ${ list.title } list.`,
            url: shareUrl,
            title: list.title,
            image: shareImage,
            style: {
                height: '12px',
                margin: '0',
                color: 'white',
            },
        };
        const facebookShareProps = {
            url: shareUrl,
            style: {
                height: '12px',
                margin: '0',
                color: 'white',
            },
        };
        const twitterShareProps = {
            url: shareUrl,
            style: {
                height: '12px',
                margin: '0',
                color: 'white',
            },
        };
        return (
            <ShareGroup
            trackShare={ this.trackShare }
            emailProps={ emailShareProps }
            facebookProps={ facebookShareProps }
            twitterProps={ twitterShareProps }
            label={ null }/>
        );
    }
}
ListCard.propTypes = {
    listItem: PropTypes.object.isRequired,
    width: PropTypes.number,
};
ListCard.defaultProps = {
    className: '',
    onLike: ( result ) => { return result; },
    onResize: () => {},
    onChange: ()=>{},
};


const mapStateToProps = ( state ) => {
    return {
        screenWidth: state.screenSize.width,
        self: state.self.user,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        noteListSearch: ( listid ) => {
            return dAPI.patch( `/lists/${ listid }/searchcount` );
        },
        noteListShare: ( listid ) => {
            return dAPI.patch( `/lists/${ listid }/sharecount` );
        },
        deleteList: ( listId ) => {
            return dAPI.delete( `/lists/${ listId }` );
        },
        publishList: ( listId ) => {
            return dAPI.patch( '/lists/' + listId, { published: true } );
        },
        redirect: ( url ) => {
            dispatch( push( url ) );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( ListCard );
